<template>
  <v-row
    justify="center"
    align="center"
    v-if="visits && visits.merged_df_final && visits.merged_df_final.length"
  >
    <v-col lg="6" cols="12" sm="6">
      <MixedCarts :dataSource="dataSource" />
    </v-col>
    <v-col lg="6" cols="12" sm="6">
      <MixedCarts :dataSource="dataSource1" />
    </v-col>
    <v-col
      cols="12"
      md="6"
      sm="12"
      lg="6"
      v-if="
        visits &&
        visits.merged_df_final_sum &&
        visits.merged_df_final_sum.length
      "
    >
      <v-card outlined>
        <v-row
          justify="center"
          align="center"
          no-gutters
          dense
          class="text-center my-2"
        >
          <v-col cols="12">
            <v-icon class="mb-1" size="23" color="#269ffb">
              mdi-account-group
            </v-icon>
            <span class="font-weight-black black--text">
              {{ $t("analytics.general.Visitors.card_elements.total_visits") }}
              :
            </span>
            <span class="subtitle-2 font-weight-black pink--text">
              {{ visits.merged_df_final_sum[0].nb_visit }}
            </span>
          </v-col>
          <v-col cols="12">
            <v-icon class="mb-1" size="23" color="#03dca0">
              mdi-cart-variant
            </v-icon>
            <span class="font-weight-black black--text">
              {{
                $t("analytics.general.Visitors.card_elements.total_add_to_card")
              }}
              :
            </span>
            <span class="subtitle-2 font-weight-black pink--text">
              {{ visits.merged_df_final_sum[0].nb_add_to_cart }}
            </span>
          </v-col>
          <v-col cols="12">
            <v-icon class="mb-1" size="23" color="#e8ae2f">mdi-wallet</v-icon>
            <span class="font-weight-black black--text">
              {{
                $t("analytics.general.Visitors.card_elements.total_purchase")
              }}
              :
            </span>
            <span class="subtitle-2 font-weight-black pink--text">
              {{ visits.merged_df_final_sum[0].nb_proceed_to_checkout }}
            </span>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
    <v-col
      cols="12"
      md="6"
      sm="12"
      lg="6"
      v-if="
        visits &&
        visits.merged_df_final_sum &&
        visits.merged_df_final_sum.length
      "
    >
      <v-card outlined min-height="99" class="text-center">
        <v-row justify="center" align="center" dense class="mt-3">
          <v-col cols="12">
            <v-icon class="mb-1" size="23" color="#03dca0">
              mdi-cart-variant
            </v-icon>
            <span class="font-weight-black black--text">
              {{
                $t(
                  "analytics.general.Visitors.card_elements.total_add_to_card_percentage"
                )
              }}
              :
            </span>
            <v-tooltip top color="black">
              <template v-slot:activator="{ on }">
                <span
                  class="subtitle-2 font-weight-black primary--text"
                  v-on="on"
                >
                  {{
                    (
                      visits.merged_df_final_sum[0].percentage_add_to_cart * 100
                    ).toFixed(2)
                  }}%
                </span>
              </template>
              <span>
                {{
                  (
                    visits.merged_df_final_sum[0].percentage_add_to_cart * 100
                  ).toFixed(9)
                }}%
              </span>
            </v-tooltip>
          </v-col>
          <v-col cols="12">
            <v-icon class="mb-1" size="23" color="#e8ae2f">mdi-wallet</v-icon>
            <span class="font-weight-black black--text">
              {{
                $t(
                  "analytics.general.Visitors.card_elements.total_purchase_percentage"
                )
              }}
              :
            </span>
            <v-tooltip top color="black">
              <template v-slot:activator="{ on }">
                <span
                  class="subtitle-2 font-weight-black primary--text"
                  v-on="on"
                >
                  {{
                    (
                      visits.merged_df_final_sum[0].percentage_checkout * 100
                    ).toFixed(2)
                  }}%
                </span>
              </template>
              <span>
                {{
                  (
                    visits.merged_df_final_sum[0].percentage_checkout * 100
                  ).toFixed(9)
                }}%
              </span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import MixedCarts from "../charts/ApexCartsMixed.vue";
export default {
  name: "generalVisitors",
  components: {
    MixedCarts,
  },
  data() {
    return {
      monthNames: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      dataSource: {
        height: 350,
        series: [
          {
            name: "visitors",
            type: "column",
            data: [],
          },
          {
            name: "add_to_card",
            type: "line",
            data: [],
          },
          {
            name: "purchase",
            type: "line",
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            height: 350,
            type: "line",
          },
          stroke: {
            show: true,
            curve: "smooth",
            lineCap: "butt",
            colors: undefined,
            width: 2,
            dashArray: 0,
          },
          dataLabels: {
            enabled: true,
            enabledOnSeries: [0, 1, 2],
          },
          labels: [],
          legend: {
            show: true,
            showForSingleSeries: true,
            showForNullSeries: true,
            showForZeroSeries: true,
            position: "bottom",
            horizontalAlign: "center",
            floating: false,
            fontSize: "14px",
          },
          xaxis: {
            type: "date",
          },
          yaxis: [
            {
              seriesName: "visitors",
              axisTicks: {
                show: true,
                color: undefined,
                offsetX: 10,
                offsetY: 0,
              },
              axisBorder: {
                show: true,
                color: "#008FFB",
                offsetX: -7,
                offsetY: 0,
              },
              labels: {
                style: {
                  colors: "#008FFB",
                },
              },
              title: {
                text: "Visitors Number",
                style: {
                  color: "#008FFB",
                },
              },
              tooltip: {
                enabled: true,
              },
            },
            {
              seriesName: "add_to_card",
              opposite: true,
              axisTicks: {
                show: true,
              },
              axisBorder: {
                show: true,
                color: "#04dca0",
                offsetX: -7,
                offsetY: 0,
              },
              labels: {
                style: {
                  colors: "#04dca0",
                },
              },
              title: {
                text: "Add to card products",
                style: {
                  color: "#04dca0",
                },
              },
              tooltip: {
                enabled: true,
              },
            },
            {
              seriesName: "purchase",
              opposite: true,
              axisTicks: {
                show: true,
              },
              axisBorder: {
                show: true,
                color: "#feb830",

                offsetX: -7,
                offsetY: 0,
              },
              labels: {
                style: {
                  colors: "#feb830",
                },
              },
              title: {
                text: "Purchase  products",
                style: {
                  color: "#feb830",
                },
              },
              tooltip: {
                enabled: true,
              },
            },
          ],
        },
      },
      dataSource1: {
        height: 350,
        type: "bar",
        series: [
          {
            name: "",
            type: "column",
            data: [],
          },
          {
            name: "",
            type: "column",
            data: [],
          },
        ],
        chartOptions: {
          colors: ["#03dca0", "#e8ae2f"],
          chart: {
            height: 350,
            type: "column",
          },
          stroke: {
            show: true,
            curve: "smooth",
            lineCap: "butt",
            colors: undefined,
            width: 2,
            dashArray: 0,
          },
          dataLabels: {
            enabled: true,
            enabledOnSeries: [0, 1],
            formatter: function (val) {
              return val.toFixed(2) + "%";
            },
          },
          labels: [],
          legend: {
            show: true,
            showForSingleSeries: true,
            showForNullSeries: true,
            showForZeroSeries: true,
            position: "bottom",
            horizontalAlign: "center",
            floating: false,
            fontSize: "14px",
          },
          xaxis: {
            type: "date",
          },
          yaxis: [
            {
              seriesName: "% Purchase / website visitors",
              opposite: false,
              axisTicks: {
                show: true,
              },
              axisBorder: {
                show: true,
                color: "#03dca0",
              },
              labels: {
                style: {
                  colors: "#03dca0",
                },
                formatter: function (val) {
                  return val ? val.toFixed(1) : val + "%";
                },
              },
              title: {
                text: "% Products per website visitors",
                style: {
                  color: "#03dca0",
                },
              },
              tooltip: {
                enabled: true,
              },
            },
            {
              seriesName: "% Purchase / website visitors",
              opposite: true,
              axisTicks: {
                show: true,
              },
              axisBorder: {
                show: true,
                color: "#e8ae2f",
              },
              labels: {
                style: {
                  colors: "#e8ae2f",
                },
                formatter: function (val) {
                  return val ? val.toFixed(1) : val + "%";
                },
              },
              title: {
                text: "% Products per website visitors",
                style: {
                  color: "#e8ae2f",
                },
              },
              tooltip: {
                enabled: true,
              },
            },
          ],
        },
      },
    };
  },
  computed: {
    visits() {
      const data = this.$store.state.analytics.visitors;
      return data;
    },
  },
  async created() {
    if (this.visits && this.visits.merged_df_final) await this.init_vals();
  },
  methods: {
    init_vals() {
      console.log("init val visit", this.visits.merged_df_final);
      for (let i = 0; i < this.visits.merged_df_final.length; i++) {
        const element = this.visits.merged_df_final[i];
        this.dataSource.chartOptions.labels.push(
          `${this.monthNames[element.month - 1]} - ${element.year}`
        );
        this.dataSource.series[0].data.push(element.nb_visit);
        this.dataSource.series[0].name = this.$t(
          "analytics.general.Visitors.graph_elements.Number_visitors"
        );
        this.dataSource.series[1].data.push(element.nb_add_to_cart || 0);
        this.dataSource.series[1].name = this.$t(
          "analytics.general.Visitors.graph_elements.products_add_to_cart"
        );
        this.dataSource.series[2].data.push(
          element.nb_proceed_to_checkout || 0
        );
        this.dataSource.series[2].name = this.$t(
          "analytics.general.Visitors.graph_elements.products_purchase"
        );

        this.dataSource1.chartOptions.labels.push(
          `${this.monthNames[element.month - 1]} - ${element.year}`
        );
        const val1 = (element.nb_proceed_to_checkout / element.nb_visit) * 100;
        const val2 = (element.nb_add_to_cart / element.nb_visit) * 100;
        this.dataSource1.series[1].data.push(val1.toFixed(2));
        this.dataSource1.series[1].name = this.$t(
          "analytics.general.Visitors.graph_elements.purchase_website_visitors"
        );
        this.dataSource1.series[0].data.push(val2.toFixed(2));
        this.dataSource1.series[0].name = this.$t(
          "analytics.general.Visitors.graph_elements.add_to_cart_website_visitors"
        );
      }
    },
  },
};
</script>
